import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-card">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Link to="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Home
              </Button>
            </Link>
            <h1 className="text-xl font-bold">Cookie Policy</h1>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Cookie Policy</CardTitle>
            <p className="text-muted-foreground">
              Last updated: January 15, 2025
            </p>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none">
            <h2>What Are Cookies</h2>
            <p>
              Cookies are small text files that are placed on your computer or
              mobile device when you visit our website. They are widely used to
              make websites work more efficiently and to provide information to
              website owners.
            </p>

            <h2>How We Use Cookies</h2>
            <p>
              We use cookies to improve your experience on our website, analyze
              site traffic, and personalize content. We may also use cookies to
              remember your preferences and settings.
            </p>

            <h2>Types of Cookies We Use</h2>
            <ul>
              <li>
                <strong>Essential Cookies:</strong> These are necessary for the
                website to function properly.
              </li>
              <li>
                <strong>Analytics Cookies:</strong> These help us understand how
                visitors interact with our website.
              </li>
              <li>
                <strong>Functional Cookies:</strong> These remember your
                preferences and settings.
              </li>
              <li>
                <strong>Marketing Cookies:</strong> These are used to deliver
                relevant advertisements.
              </li>
            </ul>

            <h2>Managing Cookies</h2>
            <p>
              You can control and manage cookies in various ways. Please note
              that removing or blocking cookies can impact your user experience
              and parts of our website may no longer be fully accessible.
            </p>

            <h2>Contact Us</h2>
            <p>
              If you have any questions about our Cookie Policy, please contact
              us at{" "}
              <a
                href="mailto:info@orctatech.com"
                className="text-primary hover:underline"
              >
                info@orctatech.com
              </a>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CookiePolicy;
